"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZugentlastungFormatter = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const ZugentlastungFormValidator_1 = require("./ZugentlastungFormValidator");
class ZugentlastungFormatter {
    static hoehe(options) {
        const basicOptions = Object.assign({}, options, {
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            unit: options.unitSystem === echain_shared_i18n_1.UnitSystem.metric ? echain_shared_quantities_1.LengthUnits.mm : echain_shared_quantities_1.LengthUnits.inch,
            precision: options.unitSystem === echain_shared_i18n_1.UnitSystem.metric ? 0 : 2,
        });
        return new echain_shared_form_validation_1.BasicQuantityFormatter(basicOptions);
    }
    static durchmesser(options) {
        const basicOptions = Object.assign({}, options, {
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            unit: options.unitSystem === echain_shared_i18n_1.UnitSystem.metric ? echain_shared_quantities_1.LengthUnits.mm : echain_shared_quantities_1.LengthUnits.inch,
            precision: options.unitSystem === echain_shared_i18n_1.UnitSystem.metric ? 0 : 2,
        });
        return new echain_shared_form_validation_1.BasicQuantityFormatter(basicOptions);
    }
    static breite(options) {
        return ZugentlastungFormValidator_1.ZugentlastungFormValidator.breite(options);
    }
    static gewicht(options) {
        return ZugentlastungFormValidator_1.ZugentlastungFormValidator.gewicht(options);
    }
}
exports.ZugentlastungFormatter = ZugentlastungFormatter;
//# sourceMappingURL=ZugentlastungFormatter.js.map